module.exports = __webpack_public_path__ + "img/1.393aa7f4.jpg";